/**
 * Replace spaces in `calc()`
 * @param {String} input
 * @returns {String}
 */
const replaceCalcSpaces = (input) => {
  if (input.includes("calc(")) {
    return input.replace(/calc\((.*?)\)+/g, (/** @type {String} */ string) => {
      return string.replace(/ /g, "▄");
    });
  } else {
    return input;
  }
};

export default replaceCalcSpaces;
